/**
 * Step-bar labels for the signup flow. Achievers walk 3 steps; Experts walk 4,
 * with the S.T.A.R. Portfolio split out of Operator DNA into its own step.
 * Shared so every step page shows the same bar and nothing relabels mid-flow.
 */
export const ACHIEVER_SIGNUP_STEP_LABELS = ["Account", "Profile", "Growth"];
export const EXPERT_SIGNUP_STEP_LABELS = ["Account", "Profile", "Operator DNA", "STAR Portfolio"];

export const getSignupStepLabels = (isExpert: boolean): string[] =>
  isExpert ? EXPERT_SIGNUP_STEP_LABELS : ACHIEVER_SIGNUP_STEP_LABELS;
